import { atom } from 'recoil';
import { TDataGridState } from '@types';

export const DataGridState = atom<TDataGridState>({
	key: '@Ofload/DataGridGlobalState',
	default: {}
});
